module.exports = __webpack_public_path__ + "img/celebrityLensman.a27f9a0a.png";